module.exports = __webpack_public_path__ + "img/070-night-1.b9ecc289.svg";